import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    feature_flags: [],
  },
  mutations: {
    ...mutations,
  },
  actions: {
    ...actions,
  },
  getters: {
    ...getters,
  },
}
